import type { SeriesDisplayConfig } from '../_shared/EconomicsPageContent';

export const CPI_SERIES: SeriesDisplayConfig[] = [
  { eventName: 'CPI (YoY)', label: 'CPI YoY', fullLabel: 'CPI (YoY)', color: '#2e79f6', chartGroup: 'YoY' },
  { eventName: 'Core CPI (YoY)', label: 'Core YoY', fullLabel: 'Core CPI (YoY)', color: '#10b981', chartGroup: 'YoY' },
  { eventName: 'CPI (MoM)', label: 'CPI MoM', fullLabel: 'CPI (MoM)', color: '#f59e0b', chartGroup: 'MoM' },
  { eventName: 'Core CPI (MoM)', label: 'Core MoM', fullLabel: 'Core CPI (MoM)', color: '#8b5cf6', chartGroup: 'MoM' },
];
